// extracted by mini-css-extract-plugin
export var closemodal = "index-module--closemodal--59f8d";
export var modal = "index-module--modal--83d7f";
export var modalcontent = "index-module--modalcontent--2ca90";
export var overlay = "index-module--overlay--62749";